export const copyright = (): void => {
  const year = document.querySelector('.copyright-year');
  if (year) {
    year.textContent = new Date().getFullYear().toString();
  }
};
